<template>
  <div class="col-12 col-lg-3 col-xl-3 col-md-3 d-flex align-items-center d-md-block d-xl-block d-lg-block">
    <button type="button" class="btn btn-back d-block d-xl-none d-md-none d-lg-none" @click="$router.push('/jobs')" />
    <div class="flex flex-column flex-lg-row flex-xl-row flex-md-row">
      <button type="button" class="btn btn-back d-none d-xl-block d-md-block d-lg-block" @click="$router.push('/jobs')" />
      <span class="d-flex refId pr-1">
        <img
          class="flat-rate-indicator pr-1"
          v-if="isFlatRate"
          src="../../assets/img/flat-rate-job-icon.svg"
          alt="Flat rate job icon"
        />
        {{ refId }}
      </span>
      <div v-if="status">
        <span v-if="status.name === 'Accepted'"
              :class="'btn-status btn-active'"
        >{{ status.name }}</span>
        <span v-else-if="status.name === 'On Hold'"
              :class="'btn-status btn-rejected'"
        >{{ status.name }}</span>
        <span v-else-if="status.name === 'Pending'"
              :class="'btn-status btn-pending'"
        >{{ status.name }}</span>
        <span v-else-if="status.name === 'Created'"
              :class="'btn-status btn-created'"
        >{{ status.name }}</span>
        <span v-else-if="status.name === 'Canceled'"
              :class="'btn-status btn-cancelled'"
        >{{ status.name }}</span>
        <span v-else-if="status.name === 'In Progress'" :class="'btn-status btn-inprogress'">{{ status.name }}</span>
        <span v-else-if="status.name === 'Tracking done'" :class="'btn-status btn-inprogress'">{{ status.name }}</span>
        <span v-else-if="status.name === 'Collect payment'" :class="'btn-status btn-inprogress'">{{ status.name }}</span>
        <span v-else-if="status.name === 'Completed'"
              :class="'btn-status btn-completed'"
        >{{ status.name }}</span>
        <span v-else-if="status.name === 'Rejected'"
              :class="'btn-status btn-rejected'"
        >{{ status.name }}</span>
        <span v-else :class="'btn-status btn-inprogress'">{{ status.name }}</span>
      </div>
    </div>
    <label class="header-source d-none d-lg-block d-xl-block d-md-block">
      {{ source && source.name }}
      <span class="disabled" v-if="leadSource.name">({{ leadSource.name }})</span>
    </label>
  </div>
</template>
<script>
export default {
  props: {
    leadSource: {
      type: Object,
      default: () => {},
    },
    status: {
      type: Object,
      default: () => {},
    },
    source: {
      type: Object,
      default: () => {},
    },
    refId: {
      type: String,
      default: '',
    },
    isFlatRate: {
      type: Boolean,
      default: false,
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/jobs/JobStatus.vue